module.exports = __webpack_public_path__ + "img/rascrut-5.2a7243c6.jpg";